module.exports = __webpack_public_path__ + "img/10.0774b615.jpg";